export enum GamButtonSize {
  LARGE = 'large',
  ACTIONS = 'actions',
  SMALL = 'small',
  X_SMALL = 'x-small',
  TINY = 'tiny',
}

export enum GamButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  AFFORDED = 'afforded',
  STEKLO = 'steklo',
  SLAB = 'slab',
  HYPE = 'hype',
}

export enum GamButtonMessageVariant {
  DEFAULT = 'default',
  ERROR = 'error',
}
